import { Typography, XStack } from '@shinetools/lumen-react'
import { FC, ReactElement } from 'react'

export interface MainSettingCtaProps {
  description: string | ReactElement
  ctaContent?: ReactElement
}

export const MainSettingCta: FC<MainSettingCtaProps> = ({ description, ctaContent }) => {
  return (
    <XStack justify="space-between" align="center">
      <div>
        <Typography.Text size="medium" weight="regular" color="var(--lumen-color-content-neutral-medium)">
          {description}
        </Typography.Text>
      </div>
      {ctaContent ? <div>{ctaContent}</div> : null}
    </XStack>
  )
}
